import { useEffect, useRef } from 'react'
import { SlidersHorizontal } from 'lucide-react'
import { cn } from '@/utils/cn'
import { PAGE_TOOLBAR } from '@/components/ui/page-toolbar'

type Props = {
  open: boolean
  onToggle: () => void
  onClose: () => void
  advancedFilterCount?: number
  panel: React.ReactNode
}

export function GestorTabFiltersPopover({
  open,
  onToggle,
  onClose,
  advancedFilterCount = 0,
  panel,
}: Props) {
  const rootRef = useRef<HTMLDivElement>(null)
  const highlighted = open || advancedFilterCount > 0

  useEffect(() => {
    if (!open) return

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }

    const onPointerDown = (e: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(e.target as Node)) {
        onClose()
      }
    }

    document.addEventListener('keydown', onKeyDown)
    document.addEventListener('mousedown', onPointerDown)
    return () => {
      document.removeEventListener('keydown', onKeyDown)
      document.removeEventListener('mousedown', onPointerDown)
    }
  }, [open, onClose])

  return (
    <div ref={rootRef} className='relative shrink-0'>
      <button
        type='button'
        onClick={onToggle}
        aria-expanded={open}
        aria-haspopup='dialog'
        className={cn(
          'closer-toolbar-field-shell flex min-h-[44px] shrink-0 items-center gap-2 rounded-xl px-4 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-accent/25',
          highlighted ? 'text-accent' : 'text-text-secondary hover:text-text-primary',
        )}
      >
        <SlidersHorizontal size={15} aria-hidden />
        <span>Filtros</span>
        {advancedFilterCount > 0 && (
          <span className={PAGE_TOOLBAR.filterBadge}>{advancedFilterCount}</span>
        )}
      </button>
      {panel}
    </div>
  )
}
